/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeContentRpc
 */

export const AssetCoordinatesDiscriminantKey = '@c';
export const CompositeTargetingConfigTypename = 'com.hubspot.personalize.models.CompositeTargetingConfig';
export const CompositeTargetingConfigDiscriminant = 'COMPOSITE';
export const CompositeTargetingConfigDiscriminantKey = 'type';
export const LandingPageCoordinatesTypename = 'com.hubspot.personalize.models.LandingPageCoordinates';
export const LandingPageCoordinatesDiscriminant = '.LandingPageCoordinates';
export const LandingPageCoordinatesDiscriminantKey = '@c';
export const MarketingEmailCoordinatesTypename = 'com.hubspot.personalize.models.MarketingEmailCoordinates';
export const MarketingEmailCoordinatesDiscriminant = '.MarketingEmailCoordinates';
export const MarketingEmailCoordinatesDiscriminantKey = '@c';
export const SegmentTargetingConfigTypename = 'com.hubspot.personalize.models.SegmentTargetingConfig';
export const SegmentTargetingConfigDiscriminant = 'SEGMENT';
export const SegmentTargetingConfigDiscriminantKey = 'type';
export const TargetingConfigDiscriminantKey = 'type';
export const WebInteractiveCoordinatesTypename = 'com.hubspot.personalize.models.WebInteractiveCoordinates';
export const WebInteractiveCoordinatesDiscriminant = '.WebInteractiveCoordinates';
export const WebInteractiveCoordinatesDiscriminantKey = '@c';
export const WebsitePageCoordinatesTypename = 'com.hubspot.personalize.models.WebsitePageCoordinates';
export const WebsitePageCoordinatesDiscriminant = '.WebsitePageCoordinates';
export const WebsitePageCoordinatesDiscriminantKey = '@c';
export const createVariantRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeContentRpc',
  rpcName: 'createVariant',
  auth: 'app',
  fingerprint: 'RYhkvrYhU7xKG4TT6LzSnTCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePersonalizationRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeContentRpc',
  rpcName: 'deletePersonalization',
  auth: 'app',
  fingerprint: 'JZhCxIAXXPo4-bu8O4MxSjCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePersonalizationByAssetCoordinatesRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeContentRpc',
  rpcName: 'deletePersonalizationByAssetCoordinates',
  auth: 'app',
  fingerprint: 'gsA5-_bHppQ4-bu8O4MxSjCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePersonalizationStrategyRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeContentRpc',
  rpcName: 'deletePersonalizationStrategy',
  auth: 'app',
  fingerprint: 'ojW6h-er-855_hIxQgY7zzCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePersonalizedDefaultRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeContentRpc',
  rpcName: 'deletePersonalizedDefault',
  auth: 'app',
  fingerprint: 'Gq2BAV_gwRePwCyCO6ymWDCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};